<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">联级题</div>
    <div class="title-view">
      <!-- <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
        </span>
      </p> -->

      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>

    <div class="cascader-select">
      <div class="select" v-for="(title, idx) in titles" :key="idx">
        {{ title }}
      </div>
    </div>

    <el-select
      v-model="firstValue"
      :placeholder="titles[0]"
      style="width: 100%; border: 1px solid #edeff2; border-radius: 3px"
      @change="handleChange"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.label"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <el-select
      v-if="
        options[Number(selectedIndices[0])] &&
        options[Number(selectedIndices[0])].children &&
        options[Number(selectedIndices[0])].children.length
      "
      v-model="secondValue"
      :placeholder="titles[1]"
      style="
        width: 100%;
        border: 1px solid #edeff2;
        margin-top: 5px;
        border-radius: 3px;
      "
    >
      <el-option
        v-for="item in secondOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>

    <el-select
      v-if="
        options[Number(selectedIndices[0])] &&
        options[Number(selectedIndices[0])].children &&
        options[Number(selectedIndices[0])].children[
          Number(selectedIndices[1])
        ] &&
        options[Number(selectedIndices[0])].children[Number(selectedIndices[1])]
          .children &&
        options[Number(selectedIndices[0])].children[Number(selectedIndices[1])]
          .children.length
      "
      v-model="thirdValue"
      :placeholder="titles[2]"
      style="
        width: 100%;
        border: 1px solid #edeff2;
        margin-top: 5px;
        border-radius: 3px;
      "
    >
      <el-option
        v-for="item in thirdOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>

    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>

    <div class="upload-file">
      <div class="file-item" v-for="(file, index) in fileList" :key="index">
        <div class="filename">
          <img
            class="icon"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1762401082820.svg"
          />
          <span>{{ file.fileName || `文件${index + 1}` }}</span>
        </div>
        <div class="down">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1761210480786.svg"
            mode=""
          />
          下载
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      images: [],
      fileList: [],
      options: [], // 用于存储联级选项数据
      selectedIndices: [0, 0, 0],
      selectedLabels: ["", "", ""],
      titles: ["一级选项", "二级选项", "三级选项"],
      isInit: false,
      firstValue: "",
      secondValue: "",
      thirdValue: "",
      firstOptions: [],
      secondOptions: [],
      thirdOptions: [],
      firstShow: false,
      secondShow: false,
      thirdShow: false,
    };
  },
  methods: {
    handleChange() {
      const selectedValues = this.selectedIndices
        .map((idx, level) => {
          const option = this.options[idx];
          if (option) {
            return option.label;
          }
          return "";
        })
        .filter(Boolean);

      this.selectedLabels = selectedValues;

      this.dataObj.context = selectedValues.join("/");

      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          answer: {
            question_id: this.dataObj.id,
            type: this.dataObj.type,
            context: this.dataObj.context,
          },
        }),
      );
    },
  },
  watch: {
    params: {
      handler(nv, ov) {
        if (!nv) return;

        console.log("nv312312312312321", nv);

        const payload = nv.data
          ? nv
          : {
              data: nv,
            };
        const data = payload.data || {};

        this.dataObj = data;
        this.index = nv.index;
        this.images = JSON.parse(data.caseProblemImg || "[]");
        this.titles = data.elseConfig
          ? data.elseConfig.split(",")
          : ["一级选项", "二级选项", "三级选项"];

        let chooseListData = {};
        try {
          chooseListData = JSON.parse(data.chooseList || "{}");
        } catch (e) {
          console.error("解析 chooseList 失败:", e);
        }

        this.options = chooseListData.options || [];

        console.log("this.optionshahahaahahahahahah", this.options);

        const valueStr = chooseListData.value || "";
        const valueArr = valueStr
          .split("/")
          .map((s) => s.trim())
          .filter(Boolean);
        this.firstValue = valueArr[0] || "";
        this.secondValue = valueArr[1] || "";
        this.thirdValue = valueArr[2] || "";

        this.firstOptions = this.options;

        // 通过firstValue获取secondOptions
        for (let i = 0; i < this.options.length; i++) {
          if (this.options[i].value === this.firstValue) {
            this.secondOptions = this.options[i].children || [];
            break;
          }
        }

        console.log("this.secondOptions", this.secondOptions);

        // 通过secondValue获取thirdOptions
        for (let i = 0; i < this.secondOptions.length; i++) {
          if (this.secondOptions[i].value === this.secondValue) {
            this.thirdOptions = this.secondOptions[i].children || [];
            break;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.file-item {
  margin-top: 8px;
}

.file-link {
  color: #3a60ff;
  text-decoration: underline;
  cursor: pointer;
}

.upload-file {
  margin: 10px 0;
}

.upload-file .file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-file .file-item .filename {
  max-width: 90%;
  display: flex;
  align-items: center;
  gap: 8.5px;
}

.upload-file .file-item .filename .icon {
  width: 24px;
  height: 21px;
  flex: none;
}

.upload-file .file-item .filename span {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #333;
}

.upload-file .file-item + .file-item {
  margin-top: 5px;
}

.upload-file .file-item .down {
  width: 59px;
  height: 31.5px;
  background: #3a60ff;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5.5px;
}

.upload-file .file-item .down img {
  width: 10px;
  height: 12px;
}

.cascader-select {
  margin: 10px 0;
}

.cascader-select .select {
  width: 100%;
  background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 3px;
  font-size: 14px;
  color: #2b2f36;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 15px;
  position: relative;
}

.cascader-select .select + .select {
  margin-top: 5px;
}

.cascader-select .select::after {
  display: block;
  content: "";
  width: 8px;
  height: 8px;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%) rotate(45deg);
  margin-top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewCASCADER.vue